"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 48.72",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: `.cls-1{fill:#e95642;}.cls-2{fill:#32bbce;}.cls-3{fill:#412148;}`
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "cls-1",
        d: "M10.1,18.69l12.13-3.55L45.1,33.46a36.22,36.22,0,0,0,3,5.47Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "cls-2",
        d: "M25.39,0l9.45,0L42.71,12.3A36,36,0,0,0,42.08,19v0Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "cls-3",
        d: "M0,41.05,13.4,34.1,57.48,48.54l.15.1Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "cls-3",
        d: "M69.54,48.72h0Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "cls-3",
        d: "M95.63,0A29.72,29.72,0,0,1,100,9.26H80.58v37.5a31.32,31.32,0,0,1-11,2h0V9.26H53.91L48,0Z"
      })]
    })
  })]
}));